<template>
  <section class="login-section">
    <div class="section-left">
      <img class="logo-img" :src="logoImg" @click="$router.push('/')" />
      <p v-if="['login', 'forgetPsd', 'resetPsd'].includes(loginStatus)" class="login-bg-msg">
        {{ $t('form.loginBgMsg') }}
      </p>
      <p v-if="loginStatus === 'register'" class="login-bg-msg">
        {{ $t('form.registerTitleMsg') }}
      </p>
      <p v-if="loginStatus === 'register'" class="login-bg-msg2">
        <!-- {{ $t('form.registerBgMsg', { coupon: `${userStore.currencyUnit}${$flatRateOrigin(2000, userStore.rate)}`}) }} -->
        {{
          $t('form.registerBgMsg', {
            coupon: '¥4300',
          })
        }}
      </p>
      <img
        v-if="loginStatus === 'login'"
        class="bg-img"
        src="@/assets/images/common/login-bg.png"
      />
      <img
        v-if="loginStatus === 'register'"
        class="bg-img"
        src="@/assets/images/common/registry-bg.png"
      />
      <img
        v-if="loginStatus === 'forgetPsd' || loginStatus === 'resetPsd'"
        class="bg-img"
        src="@/assets/images/common/password-bg.png"
      />
    </div>
    <div
      class="section-right"
      :class="{
        alignCenter: loginStatus === 'forgetPsd' || loginStatus === 'resetPsd',
      }"
    >
      <div class="login-wrapper" :class="{ isCenter: loginStatus === 'forgetPsd' }">
        <div v-if="loginStatus === 'login'" class="title">
          {{ $t('form.back') }}
        </div>
        <div v-else-if="loginStatus === 'register'" class="title title2"></div>
        <div v-else-if="loginStatus === 'forgetPsd'" class="title title3">
          {{ $t('form.accountSecurity') }}
        </div>
        <div v-else-if="loginStatus === 'resetPsd'" class="title title3">
          {{ $t('form.resetPsd') }}
        </div>

        <div class="form-content">
          <div
            v-if="!showError && (loginStatus === 'login' || loginStatus === 'register')"
            class="tip-block"
          >
            <p class="tip-up">
              <img class="shengyin" src="@/assets/images/common/shengyin.png" /><span
                class="tip-up-text"
                >{{ $t('form.announcement') }}</span
              >
            </p>
            <p class="tip-down">
              {{ $t('form.formAnnouncementMsg') }}
            </p>
          </div>
          <!-- 帐号登录&扫码登录 -->
          <LoginForm
            v-if="loginStatus === 'login'"
            @changeLoginStatus="changeLoginStatus"
            @showError="showErrorEvent"
          >
          </LoginForm>
          <RegisterForm
            v-if="loginStatus === 'register'"
            @changeLoginStatus="changeLoginStatus"
          ></RegisterForm>
          <ForgetPsd
            v-if="loginStatus === 'forgetPsd'"
            @changeLoginStatus="changeLoginStatus"
          ></ForgetPsd>
          <ResetPsd
            v-if="loginStatus === 'resetPsd'"
            @changeLoginStatus="changeLoginStatus"
          ></ResetPsd>
        </div>
      </div>
      <!-- <div class="tip-wrapper">
        <span class="text text1">{{ $t('form.termService') }}</span>
        <span class="text text2">{{ $t('form.privacyPolicy') }}</span>
        <span class="text text3">{{ $t('form.helpCenter') }}</span>
      </div> -->
      <!-- <div class="lang-wrapper"><LangChange></LangChange></div> -->
    </div>
  </section>
</template>
<script>
import { useUserStore } from '@/stores'
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ForgetPsd from './components/ForgetPsd'
import LoginForm from './components/LoginForm'
import RegisterForm from './components/RegisterForm'
import ResetPsd from './components/ResetPsd'

export default {
  name: 'PageLogin',
  components: { LoginForm, RegisterForm, ForgetPsd, ResetPsd },
  setup() {
    const userStore = useUserStore()
    const $route = useRoute()
    const $router = useRouter()
    const loginStatus = computed(() => $route.query.loginStatus || 'login')
    const showError = ref(false)
    // 导航跳到注册页面
    if ($route.query.loginStatus === 'register' && $route.query.code) {
      $router.push({
        query: { loginStatus: 'register', code: $route.query.code },
      })
    } else {
      if ($route.query?.isLogin === 'false') {
        // loginStatus.value = 'register';
        $router.push({ query: { loginStatus: 'register' } })
      } else if ($route.query?.account) {
        $router.push({ query: { loginStatus: 'resetPsd' } })
      }

      // 存储回跳地址
      userStore.setRedirectUrl($route.query.redirectUrl || '/')
    }
    const logoImg = computed(() => {
      if (userStore.themeMode === 'light') {
        return require(`@/assets/images/common/logo-light.png`)
      } else {
        return require(`@/assets/images/common/logo-light.png`)
      }
    })

    const changeLoginStatus = (status) => {
      // $router.push({ query: { loginStatus: status } });
      const newquery = { ...$route.query, loginStatus: status }
      $router.push({ query: newquery })
    }
    const showErrorEvent = (isShow) => {
      showError.value = isShow
    }
    return {
      loginStatus,
      changeLoginStatus,
      showError,
      showErrorEvent,
      userStore,
      logoImg,
    }
  },
}
</script>
<style scoped lang="scss">
::v-deep {
  .el-form-item__error {
    position: static;
  }
}

.login-section {
  width: 100%;
  height: 100vh;
  display: flex;
  position: relative;
  background-color: var(--white-color-1);

  .section-left {
    width: 45%;
    height: 100vh;
    background: #e5f5ee;
    position: relative;

    .logo-img {
      width: 126px;
      height: 42px;
      margin-top: 28px;
      margin-left: 80px;
      cursor: pointer;
    }

    .login-bg-msg {
      font-size: 36px;
      font-weight: bold;
      color: var(--primary-color);
      margin-top: 100px;
      margin-left: 80px;
    }

    .login-bg-msg2 {
      font-size: 24px;
      font-weight: bold;
      color: var(--primary-color);
      margin-top: 50px;
      margin-left: 80px;
    }

    .bg-img {
      position: absolute;
      bottom: 0;
      left: 60px;
      width: 636px;
      height: 432px;
    }
  }

  .section-right {
    background: var(--white-color-1);
    height: 100vh;
    position: relative;

    .login-wrapper {
      width: 400px;
      margin-left: 260px;
      background: var(--white-color-1);

      .form-content {
        position: relative;
      }

      .title {
        margin-top: 160px;
        font-family: Montserrat;
        font-size: 32px;
        font-weight: bold;
        color: var(--black-color-3d);
      }

      .tip-block {
        width: 400px;
        padding: 12px;
        background: var(--background-primary-light1);
        border-radius: 8px;
        margin-top: 20px;
        min-height: 64px;
        color: var(--primary-color);

        .tip-up {
          font-size: 12px;
          font-weight: 600;
          display: flex;
          align-items: center;

          .shengyin {
            width: 16px;
            height: 16px;
          }

          .tip-up-text {
            margin-left: 10px;
          }
        }

        .tip-down {
          font-size: 12px;
          margin-top: 8px;
        }
      }

      .title2 {
        margin-top: 120px;
      }

      .title3 {
        margin-top: 0px;
      }
    }

    .tip-wrapper {
      position: absolute;
      left: 260px;
      bottom: 40px;
      width: 400px;
      text-align: center;
      font-family: Montserrat;
      font-size: 12px;
      color: var(--black-color-6);
      height: 15px;
      line-height: 15px;

      .text {
        padding: 0 10px;
        cursor: pointer;

        &:hover {
          color: var(--primary-color);
        }
      }

      .text1,
      .text2 {
        border-right: 1px solid var(--black-color-6);
      }
    }

    .lang-wrapper {
      position: absolute;
      top: 40px;
      right: 0px;
    }
  }

  .alignCenter {
    display: flex;
    align-items: center;
  }
}

// 二维码容器
.qrcode-box {
  text-align: center;
  padding-top: 40px;

  p {
    margin-top: 20px;

    a {
      color: $xtxColor;
      font-size: 16px;
    }
  }
}
</style>
